export const valuesSectionStyles = () => {
  return {
    container: {
      position: 'relative',
      width: '100%',
      height: {xs: '100vh', lg: '120vh'},
      background: 'linear-gradient(173deg, #252629 74.9%, #ffffff 75%, #ffffff 75.5%)',
      overflow: 'hidden',
    },
    contentContainer: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding:  {xs: '20px', lg: '75px 100px'},

    },
    heading: {
      // Additional heading styles if needed
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
    },
    title: {
      // Additional title styles if needed
    },
    couchBackground: {
      position: 'absolute',
      top: {xs: "65%", lg: '55%'},
      left: {xs: '50%', lg: '55%'},
      transform: 'translate(-50%, -50%)',
      width: '120%',
      height: '120%',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      zIndex: 1,
      pointerEvents: 'none',
    },
    iconInfoSection1: {
      position: {xs: "relative", lg: 'absolute'},
      top: {xs: 0, lg: '10%'},
      right: {xs: 0, lg: '20%'},
      maxWidth: {xs: '80%', lg: '375px'},
      zIndex: 3,
    },
    iconInfoSection2: {
      position: {xs: "relative", lg: 'absolute'},
      top: {xs: 0, lg: '50%'},
      left: {xs: 0, lg: '10%'},
      maxWidth: {xs: '80%', lg: '400px'},
      zIndex: 3,
    },
    iconInfoSection3: {
      position: {xs: "relative", lg: 'absolute'},
      top: {xs: 0, lg: '40%'},
      right: {xs: 0, lg: '5%'},
      maxWidth: {xs: '80%', lg: '420px'},
      zIndex: 3,
    },
  };
};

